import { render, staticRenderFns } from "./CreateBankAccount.vue?vue&type=template&id=13972f72&scoped=true"
import script from "./CreateBankAccount.vue?vue&type=script&lang=js"
export * from "./CreateBankAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateBankAccount.vue?vue&type=style&index=0&id=13972f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13972f72",
  null
  
)

export default component.exports